import {
  Icon,
  ReauthenticationVariant,
  ResourceType,
  SvgIconComponent,
} from 'shared/types'
import {
  Barrier,
  Garage,
  Door,
  Gate,
  Handle,
  Lift,
  Speedgate,
  Padlock,
} from 'shared/assets'
import { Board, Desk, Car } from 'shared/assets'
import { Locker } from 'shared/assets/globalworth'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import SpaIcon from '@mui/icons-material/Spa'

export const ResourceTypeIconMapping: Record<
  ResourceType,
  SvgIconComponent | typeof MoreHorizIcon
> = {
  [ResourceType.ConferenceRoom]: Board,
  [ResourceType.Desk]: Desk,
  [ResourceType.ParkingSpot]: Car,
  [ResourceType.Locker]: Locker,
  [ResourceType.Other]: MoreHorizIcon,
  [ResourceType.Sauna]: SpaIcon,
}

export const mapNumberToReauthenticationVariant = (
  value: number
): ReauthenticationVariant | null => {
  if (Object.values(ReauthenticationVariant).includes(value)) {
    return value as ReauthenticationVariant
  }
  return null
}

export const LockIconMapping: Record<Icon, SvgIconComponent> = {
  [Icon.Barrier]: Barrier,
  [Icon.Door]: Door,
  [Icon.Garage]: Garage,
  [Icon.Gate]: Gate,
  [Icon.Lock]: Padlock,
  [Icon.Handle]: Handle,
  [Icon.Lift]: Lift,
  [Icon.Speedgate]: Speedgate,
}
